module.exports = __webpack_public_path__ + "assets/check-fat.a186774c.svg";